import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"


//import props
import props from "@/props/pageSection";

//define the props

//import components
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "PageSection",
  inheritAttrs: true,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: props,
  setup(__props) {

//import vue


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _mergeProps(_ctx.$attrs, { class: "toolsie page section" }), [
    (_ctx.contained)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "inner",
          style: _normalizeStyle({ 'max-width': `${Math.abs(Math.round(_ctx.maxWidth as number))}px` })
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 4))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 16))
}
}

})